import * as types from 'model/actionTypes'

export function receiveOrders (orders: {}) {
  return {
    type: types.RECEIVE_ORDERS,
    orders
  }
}
